import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updatePlan = createAsyncThunk('updatePlan', async (data) => {

    var bodyFormData = new FormData();

    bodyFormData.append("id", data?.values?.id);
    bodyFormData.append("plan_name", data?.values?.plan_name);
    bodyFormData.append("amount", data?.values?.amount);
    bodyFormData.append("days", data?.values?.days);
    bodyFormData.append("description", data?.values?.description);
    bodyFormData.append("status", data?.values?.status);
    
    if (data?.values?.image) {
        bodyFormData.append("plan_image", data?.values?.image);
    }

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'plan',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

